'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TabContainer = require('react-bootstrap/lib/TabContainer');

var _TabContainer2 = _interopRequireDefault(_TabContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TabContainer2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/TabContainer.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/TabContainer.js
 ** module chunks = 0
 **/